import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../DetailTestAnalyze.scss';
import './TestPriority.scss'; 
import MapSidebar from "Components/Bars/MapSidebar";
import { CSSTransition } from 'react-transition-group'; // ES6
import { useSearchParams } from "react-router-dom";
import TestListSearch from "./TestListSearch";
import TestListResult from "./TestListResult"; // 加入顯示結果組件


const TestList = () => {
    const [searchCondition, setsearchCondition] = useState([]);
    const [mapShow, setmapShow] = useState(false);
    const [bridgeData, setbridgeData] = useState([]);
    const [selectedBridge, setselectedBridge] = useState({});
    const [searchParams, setSearchParams] = useSearchParams();
    const [specialBridge, setSpecialBridge] = useState('N');

    useEffect(() => {
        // 根據 URL 參數初始化 searchCondition
        const initialConditions = [];
        const bridgeName = searchParams.get('bridgeName') || '';
        const bridgeNumber = searchParams.get('bridgeNumber') || '';
        const testName = searchParams.get('testName') || '';
        const specialBridgeParam = searchParams.get('specialBridge') || 'N';

        if (bridgeName) {
            initialConditions.push({ key: 'bridgeName', value: bridgeName });
        }

        if (bridgeNumber) {
            initialConditions.push({ key: 'bridgeNumber', value: bridgeNumber });
        }

        if (testName) {
            initialConditions.push({ key: 'testName', value: testName });
        }

        if (initialConditions.length > 0) {
            setsearchCondition(initialConditions);
        }
        setSpecialBridge(specialBridgeParam);
    }, [searchParams]);

    const onSearch = (newConditions) => {
        // 將新條件設置到 searchCondition
        setsearchCondition(newConditions);

        // 更新 URL 中的查詢參數
        const updatedSearchParams = new URLSearchParams();
        newConditions.forEach((condition) => {
            if (condition.key && condition.value) {
                updatedSearchParams.set(condition.key, condition.value);
            }
        });
        updatedSearchParams.set('specialBridge', specialBridge); 
        setSearchParams(updatedSearchParams);
    };
    
    const ToggleMapSideBar = () => {
        setmapShow((prev) => {
            const newMapShow = !prev;
            console.log("mapShow:", newMapShow);
            return newMapShow;
        });
    };

    return (
        <>
            <div className="DetailTestAnalyze-page p-2">
                <div className="navbar-container">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="./#">儀錶板</a></li>
                        <li className="breadcrumb-item active" aria-current="page">橋梁詳檢分析儀錶板</li>
                    </ol>
                </div>
                <div className="l-grid-2row-ta__row2 o-content--rounded bg-white testPriority-form">
                    <div className="position-absolute o-content--full">
                        <div className="left-container" style={{ width: mapShow ? "50%" : "100%" }}>
                            <TestListSearch
                                testCodeList={[]} // 測試代碼列表
                                districts={[
                                    '桃園區', '中壢區', '平鎮區', '八德區', '楊梅區',
                                    '蘆竹區', '大溪區', '龜山區', '大園區', '觀音區',
                                    '新屋區', '龍潭區', '復興區'
                                ]}
                                onSearch={onSearch}
                                onClear={() => setsearchCondition([])}
                            />
                            <TestListResult
                                searchCondition={searchCondition}
                                bridgeData={bridgeData}
                                setbridgeData={setbridgeData}
                                setselectedBridge={setselectedBridge}
                                specialBridge={specialBridge}
                            />
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default TestList;